<!-- 讲义详情 -->
<template>
  <div>
    <van-popup v-model="show" position="bottom" duration="0.17" @click-overlay="close">
      <div class="section">
        <h1 class="title">
          <p>讲义详情</p>
          <van-icon @click="close" name="cross" />
        </h1>
        <div class="section-box">
          <div class="logistics">
            <div class="logistics-left">
              <button :class="{
                active: handData.deliveryStatus === 3,
                red: handData.deliveryStatus === 4,
              }">
                {{ deliveryStatus[handData.deliveryStatus] }}</button><span>{{ handData.goodsName }}</span>
            </div>
            <div class="logistics-right" v-if="handData.deliveryStatus === 3" @click="openDeliver">
              <b>查看物流</b>
              <img src="../../../../assets/img/personalImg/arrow.png" />
              <!-- <van-icon name="arrow" /> -->
            </div>
          </div>
        </div>
        <div class="address">
          <h2>讲义名称</h2>
          <div>
            <p>{{ handData.goodsName }}</p>
          </div>
        </div>
        <div class="res" v-if="handData.deliveryStatus === 4">
          <span>不发货原因：</span><b>{{ handData.noDeliverReason }}</b>
        </div>
        <div class="address">
          <h2>邮寄地址</h2>
          <div v-if="handData.addressDetail">
            <p>收件人：{{ handData.consignee }}</p>
            <p>手机号：{{ handData.phone }}</p>
            <p>收货地址：{{ handData.addressDetail }}</p>
          </div>
          <p v-else>未填写</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      deliveryStatus: {
        1: '待发货',
        2: '已打包',
        3: '已发货',
        4: '不发货',
      },
    };
  },
  props: {
    showDetail: {
      type: Boolean,
      default: false,
    },
    handData: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    showDetail(data) {
      this.show = data;
    },
  },
  components: {},

  computed: {},

  mounted() { },

  created() { },

  methods: {
    close() {
      this.$emit('close', 0);
    },
    openDeliver() {
      this.$emit('close', 2);
    },
  },
};
</script>
<style lang="scss" scoped>
.section {
  padding: 0 0 140px 0;
}

.title {
  position: relative;
  padding: 40px 0 0 0;

  p {
    color: #333;
    font-weight: 800;
    font-size: 36px;
    text-align: center;
  }

  ::v-deep .van-icon-cross {
    position: absolute;
    top: 18px;
    right: 18px;
    font-size: 20px;
  }
}

.logistics {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  width: 670px;
  margin: 60px auto;
  padding: 36px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  .logistics-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      display: inline-block;
      width: 320px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #333;
      font-weight: 500;
      font-size: 28px;
      line-height: 40px;
    }

    button {
      height: 36px;
      margin: 0 10px 0 0;
      padding: 2px 10px;
      color: #ff6c02;
      font-size: 24px;
      font-weight: 400;
      line-height: 30px;
      background: #fff;
      border: 2px solid #ff6c02;
      border-radius: 8px;
    }

    .active {
      color: #fff;
      background: #ff6c02;
    }

    .red {
      color: #fff;
      background: #ff5d5d;
      border: 1px solid #ff5d5d;
    }
  }

  .logistics-right {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;

    b {
      display: inline-block;
      color: #787878;
      font-weight: 400;
      font-size: 28px;
    }

    img {
      position: relative;
      top: -1px;
      width: 12px;
      height: 24px;
      margin: 0 0 0 12px;
    }
  }
}

.res {
  padding: 0 40px 40px 40px;

  span {
    color: #333;
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
  }

  b {
    color: #787878;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
  }
}

.address {
  margin-bottom: 25px;
  padding: 0 40px;

  h2 {
    padding: 0 0 32px 0;
    color: #333;
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
  }

  p {
    padding: 0 0 16px 0;
    color: #787878;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
  }
}
</style>
